import { useState } from "react";
import { Box } from "@mantine/core";
import WizardHeader from "../Common/Header/WizardHeader";
import { type PageName } from "../NoShow/Common/Common";
import PageContactQuickForm from "./PageContactQuickForm";

interface ContactsQuickAddWizardProps {
  closeModal?: () => void;
  onCreated?: (contactId: string) => void;
  fromLookup?: boolean;
}

const DEFAULT_TOTAL_PAGES = 1;

export default function ContactsQuickAddWizard({
  closeModal,
  onCreated,
  fromLookup = false,
}: ContactsQuickAddWizardProps) {
  const [totalPages, setTotalPages] = useState(DEFAULT_TOTAL_PAGES);
  const [pages, setPages] = useState<PageName[]>(["COMPLETED"]);

  return (
    <Box h={"80vh"}>
      <WizardHeader
        defaultTotalPages={DEFAULT_TOTAL_PAGES}
        setPages={setPages}
        setTotalPages={setTotalPages}
        pages={pages}
        totalPages={totalPages}
        closeModal={closeModal}
      />
      <PageContactQuickForm
        closeModal={closeModal}
        onCreated={onCreated}
        fromLookup={fromLookup}
      />
    </Box>
  );
}
